import React, { useEffect, useState } from "react";
import message from "./store/reducers/message";
import session from "./store/reducers/session";
import source from "./store/reducers/source";
import user from "./store/reducers/user";
import events from "./store/reducers/events";
import event from "./store/reducers/event";
import teams from "./store/reducers/teams";
import all_teams from "./store/reducers/all_teams";
import team from "./store/reducers/team";
import number from "./store/reducers/carNumber";
import carValues from "./store/reducers/carValues";
import racingBracket from "./store/reducers/racingBracket";
import check from "./store/reducers/check";
import { routes } from "./navigation/routes";
import { Message } from "../src/containers/message";
import { Header } from "../src/navigation";
import HashRouter from "react-router-dom/es/HashRouter";
import { Box } from "@material-ui/core";
import { useSelector } from "react-redux";


export const reducers = {
  message,
  session,
  source,
  user,
  events,
  teams,
  team,
  number,
  carValues,
  racingBracket,
  event,
  all_teams,
  check,
};

function App() {
  const isLoggedIn = useSelector((state) => state.session);
  const [isSessionInitialized, setSessionInitialized] = useState(false);
  useEffect(() => {
    if (isLoggedIn) {
      setSessionInitialized(true);
    }
  }, [isLoggedIn]);

  return (
    <Box
      display={["block", "block", "block", "flex"]}
      p={isSessionInitialized ? 2 : 0}
      id={isSessionInitialized && "memberAreaSection"}
      className="appLayout"
    >
      <Message />
      <Box
        display="flex"
        className={isSessionInitialized && "headerMenuMemberArea"}
      >
        <Header />
      </Box>
      <Box width="100%">
        <HashRouter>{routes}</HashRouter>
      </Box>
    </Box>
  );
}

export default App;
